export const toFirstLetterToUpperCase = (string) => {
    if (string.length < 1) return '';
    const lowerCaseString = string.toLowerCase();
    const firstLetterUpperCase = lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1);
    return firstLetterUpperCase;
};
